"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgSlowTraffic(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 -4 18 24" }, props),
        React.createElement("path", { d: "M6 11v2H3v-2zm12.625-2.295l-.111-.305-.867.868-1.414-1.414 1.252-1.253A6.783 6.783 0 0013.3 4.095L13 4.05V6h-2V4.104a6.704 6.704 0 00-3.107 1.45l-.24.208 5.88 6.65a1.5 1.5 0 11-2.348 1.81L3.85 3.62l1.268-.91L6.38 4.231C7.963 2.82 10 2 12.178 2c4.79 0 8.68 3.892 8.818 8.735L21 11v2h-3v-2h1c0-.804-.133-1.576-.375-2.295zM4.116 6.642L5.44 8.604a7.077 7.077 0 00-.406 2.037L5.025 11H3a9 9 0 011.116-4.358z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('SlowTraffic')(SvgSlowTraffic);
//# sourceMappingURL=SlowTraffic.js.map